import { ArrowDropDown as ArrowDropDownIcon } from '@mui/icons-material';
import { Button, ButtonProps, MenuItem } from '@mui/material';
import { useMemo, useState } from 'react';
import { CSVLink } from 'react-csv';
import Menu from '../../../../components/Menu';
import { getCsvDataForDashboard, getFilenameForDashboard } from './HatDbExportUtils';
import { useHatDbContext } from '../../context/HatDbContext';
import { useHatDbDataContext } from '../../context/HatDbDataContext';
import { ExportMethod, HatDbExportDialog } from './HatDbExportDialog';

export function HatDbExportMenuButton(props: ButtonProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const hatDbContext = useHatDbContext();
    const hatDbDataContext = useHatDbDataContext();

    const [exportDialog, setExportDialog] = useState<{
        dialogOpen: boolean;
        exportMethod: ExportMethod;
    }>({
        dialogOpen: false,
        exportMethod: ExportMethod.download,
    });

    const csvFilename = useMemo(() => {
        return getFilenameForDashboard(hatDbContext);
    }, [hatDbContext]);

    // Rather annoyingly react-csv is broken and will not accept a function for the data prop.
    // So render and memoize the data instead of doing it on demand.
    // TODO Consider: react-papaparse as a newer replacement.
    // See: https://github.com/react-csv/react-csv/issues/375
    // See: https://github.com/react-csv/react-csv/issues/322
    const csvData = useMemo(() => {
        if (hatDbDataContext !== null) {
            return getCsvDataForDashboard(hatDbContext, hatDbDataContext);
        } else {
            return [];
        }
    }, [hatDbContext, hatDbDataContext]);

    return (
        <div>
            <Button
                id="hat-export-menu-button"
                aria-controls={open ? 'hat-export-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="outlined"
                disableElevation
                onClick={(event) => setAnchorEl(event.currentTarget)}
                endIcon={<ArrowDropDownIcon />}
                size="medium"
                {...props}
            >
                Export
            </Button>
            <Menu
                sx={{ width: 300 }}
                slotProps={{
                    list: {
                        'aria-labelledby': 'hat-export-menu-button',
                    },
                }}
                id="hat-export-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
            >
                <MenuItem
                    disableRipple
                    onClick={() => {
                        setExportDialog((previousValue) => ({
                            ...previousValue,
                            exportMethod: ExportMethod.download,
                            dialogOpen: true,
                        }));
                    }}
                >
                    PDF
                </MenuItem>
                <MenuItem disableRipple>
                    <CSVLink
                        data={csvData}
                        filename={csvFilename}
                        style={{
                            display: 'inline-block',
                            width: '100%',
                            textDecoration: 'none',
                        }}
                    >
                        CSV
                    </CSVLink>
                </MenuItem>
                <MenuItem
                    disableRipple
                    onClick={() => {
                        setExportDialog((previousValue) => ({
                            ...previousValue,
                            exportMethod: ExportMethod.email,
                            dialogOpen: true,
                        }));
                    }}
                >
                    Email
                </MenuItem>
            </Menu>

            <HatDbExportDialog
                exportMethod={exportDialog.exportMethod}
                open={exportDialog.dialogOpen}
                onClose={() => {
                    setExportDialog((previousValue) => ({
                        ...previousValue,
                        dialogOpen: false,
                    }));
                }}
            />
        </div>
    );
}
